import React, { useEffect, useState } from "react";
import MapPicker from "../../CoreComponents/MapPicker";
import { googleApiKey } from "../../Functionalities/Config";
import { ManageSettingsAdmin } from "./Logic";

const DefaultLocation = {
  lat: 10.976,
  lng: 76.2254,
};
const DefaultZoom = 12;

const MapView = (props) => {
  const [location, setLocation] = useState(
    props.coordinates ? props.coordinates : DefaultLocation
  );
  const [zoom, setZoom] = useState(DefaultZoom);
  const [apiKey, setapiKey] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let res = ManageSettingsAdmin(
      "",
      "",
      "get",
      "param_name=googlemap_key&keyword=super_admin_conf"
    );
    res.then((result) => {
      if (result?.data?.Message?.param_value && result.data.Message.param_value !== "XXXXXXXXXXXXXX") {
        setapiKey(result.data.Message.param_value);
      } else {
        setapiKey("");
      }
    });
  };

  function handleChangeLocation(lat, lng) {
    setLocation({ lat: lat, lng: lng });
    props.onChange(lat, lng);
  }

  function handleChangeZoom(newZoom) {
    setZoom(newZoom);
  }

  return (
    <div>
      {apiKey && (
        <MapPicker
          defaultLocation={location}
          zoom={zoom}
          style={{ height: "400px", marginTop: 20 }}
          onChangeLocation={handleChangeLocation}
          onChangeZoom={handleChangeZoom}
          apiKey={apiKey ? apiKey : googleApiKey}
        />
      )}
    </div>
  );
};

export default MapView;
